module.exports = __webpack_public_path__ + "static/img/1.c14cec7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carrusel/1.png
// module id = +Klq
// module chunks = 5